if (!window.Eurus.loadedScript.has('sticky-price-observer.js')) {
  window.Eurus.loadedScript.add('sticky-price-observer.js');

  function initStickyPriceObservers() {
    const priceWrappers = document.querySelectorAll('[id^="price-"]:not([id*="sticky"])');
    priceWrappers.forEach((priceWrapper) => {
      const sectionId = priceWrapper.id.replace('price-', '');
      const stickyPriceContainers = document.querySelectorAll(`.sticky_add_to_cart .price-sticky-${sectionId} .price`);
      if (stickyPriceContainers.length === 0) return;

      const sync = () => {
        const mainPrice = priceWrapper.querySelector('.main-product-price');
        if (!mainPrice) return;
        const html = mainPrice.innerHTML;
        stickyPriceContainers.forEach((stickyPrice) => {
          stickyPrice.innerHTML = html;
        });
      };

      const observer = new MutationObserver(sync);
      observer.observe(priceWrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });

      sync();
    });
  }

  requestAnimationFrame(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyPriceObservers, { once: true });
    } else {
      initStickyPriceObservers();
    }
  });
}
